mutation TransactionRemove($input: InvoiceBatchDeleteInput!) {
  invoiceBatchDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
